import React from "react";
import ReactECharts from "echarts-for-react";
import 'echarts-liquidfill'

export default function Statuscard() {
    var options = {
        series: [{
            type: 'liquidFill',
            data: [1],
            name: 'Liquid Fill',
            amplitude: 0,
            waveAnimation: 0,
            label: {
                show: false
            }
        }],
        tooltip: {
            show: true
        }
    };

    return(
        <ReactECharts 
            option={options}
            style={{width: '100%', height: '100%'}}
        />
    )
}